/* Rede — sub-telas de Embaixadores, Empresas e Igrejas como no menu lateral dos protótipos: cada uma é uma rota
   (/staff/<área>/<slug>) e um item do seu tema no menu do Staff. `id` é o nome interno da sub-tela; `slug`, o da URL. */

export type SubView<V extends string = string> = { id: V; slug: string; label: string }

export const EMB_VIEWS = [
    { id: 'painel', slug: 'visao-geral', label: 'Visão geral' },
    { id: 'atuais', slug: 'atuais', label: 'Embaixadores atuais' },
    { id: 'busca', slug: 'busca', label: 'Motor de busca' },
    { id: 'regua', slug: 'regua', label: 'Régua de relacionamento' },
    { id: 'aprovacao', slug: 'aprovacao', label: 'Aprovação do cliente' },
    { id: 'naoaprov', slug: 'nao-aprovados', label: 'Não aprovados' },
    { id: 'buscados', slug: 'ja-buscados', label: 'Já buscados' },
] as const satisfies readonly SubView[]
export type EmbView = (typeof EMB_VIEWS)[number]['id']

export const CORP_VIEWS = [
    { id: 'painel', slug: 'visao-geral', label: 'Visão geral' },
    { id: 'atuais', slug: 'atuais', label: 'Empresas atuais' },
    { id: 'busca', slug: 'busca', label: 'Motor de busca' },
    { id: 'regua', slug: 'regua', label: 'Régua de abordagem' },
    { id: 'naoaprov', slug: 'nao-aprovadas', label: 'Não aprovadas' },
] as const satisfies readonly SubView[]
export type CorpView = (typeof CORP_VIEWS)[number]['id']

export const CHURCH_VIEWS = [
    { id: 'painel', slug: 'visao-geral', label: 'Visão geral' },
    { id: 'parceiras', slug: 'parceiras', label: 'Igrejas parceiras' },
    { id: 'busca', slug: 'busca', label: 'Busca no mapa' },
    { id: 'regua', slug: 'regua', label: 'Régua de abordagem' },
    { id: 'naoaprov', slug: 'nao-aprovadas', label: 'Não aprovadas' },
    { id: 'buscadas', slug: 'ja-buscadas', label: 'Igrejas já buscadas' },
] as const satisfies readonly SubView[]
export type ChurchView = (typeof CHURCH_VIEWS)[number]['id']

export const REDE_BASES = { embaixadores: '/staff/embaixadores', empresas: '/staff/empresas', igrejas: '/staff/igrejas' } as const

/** Sub-tela da URL; slug desconhecido → null (a rota manda para a Visão geral). */
export function viewOfSlug<V extends string>(views: readonly SubView<V>[], slug: string | undefined): V | null {
    return views.find(v => v.slug === slug)?.id ?? null
}

export function viewPath<V extends string>(base: string, views: readonly SubView<V>[], id: V): string {
    return `${base}/${views.find(v => v.id === id)?.slug ?? views[0]!.slug}`
}
